module.exports = __webpack_public_path__ + "media/img/services/services-card-img3-4a437edcd61c0d9213329c8c1377b97e.svg";